/**
 * Utilidades para formatear precios de manera consistente
 */

/**
 * Formatea un precio para mostrar solo 2 decimales
 * @param {number} price - El precio a formatear
 * @returns {string} El precio formateado con 2 decimales
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined || isNaN(price)) {
    return '0.00';
  }
  
  // Redondear a 2 decimales para evitar errores de precisión de JavaScript
  const rounded = Math.round(Number(price) * 100) / 100;
  
  // Formatear con 2 decimales, pero eliminar ceros innecesarios al final
  return rounded.toFixed(2);
};

/**
 * Formatea un precio para mostrar con el símbolo de euro
 * @param {number} price - El precio a formatear
 * @returns {string} El precio formateado con € y 2 decimales
 */
export const formatPriceWithEuro = (price) => {
  return `${formatPrice(price)} €`;
};

/** Importe en euros enteros (sin decimales), p. ej. anticipos de pago parcial. */
export const formatWholeEurosWithEuro = (price) => {
  const n = Number(price);
  if (!Number.isFinite(n)) return '0 €';
  return `${Math.round(n)} €`;
};

/**
 * Formatea un precio por día
 * @param {number} price - El precio a formatear
 * @param {string} dayText - Texto para "día" (por defecto 'día' para compatibilidad)
 * @returns {string} El precio formateado con €/{dayText}
 */
export const formatPricePerDay = (price, dayText = 'día') => {
  return `${formatPriceWithEuro(price)}/${dayText}`;
}; 